import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-24 text-center">
        <p className="font-heading text-7xl md:text-9xl font-extrabold text-primary-500/20 select-none">
          404
        </p>
        <h1 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950 mt-4">
          页面走丢了
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-md">
          抱歉，你访问的页面不存在或已被移除。返回首页，继续探索糖心视频的精彩内容吧。
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-7">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/search"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-100 text-foreground-800 text-sm font-semibold hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-search-line"></i>
            去搜索
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}